module.exports = __webpack_public_path__ + "img/img3.2d870d00.svg";